/*
 * Shared stylesheet entrypoint for the Rails application/auth layouts.
 * Keep the legacy bridge first so component-library styles retain the same
 * precedence they had when Vite followed stylesheet_link_tag in the layout.
 */
@import './legacy-application.css';
@import './auth.css';
@import './admin-job-applications.css';
@import './users.css';
@import './positions.css';
@import './admin-dashboard.css';

/* 一覧ページのタイトル行に登録導線を右寄せで置くための共通クラス(案件一覧・人材一覧)。 */
.biz-title--with-action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.biz-title--with-action .biz-title-action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px;
  border-radius: 6px;
  background: var(--mantine-color-brand-6, #3b5998);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.biz-title--with-action .biz-title-action:hover {
  opacity: 0.9;
}
